import type { User, UserManager } from "oidc-client";

class AuthService {
  private userManagerPromise: Promise<UserManager> | null = null;

  private getUserManager(): Promise<UserManager> {
    if (!this.userManagerPromise) {
      const settings = {
        authority: process.env.REACT_APP_SSO_ROOT_URL,
        client_id: process.env.REACT_APP_SSO_CLIENT_ID,
        AllowOfflineAccess: true,
        AllowAccessTokensViaBrowser: true,
        redirect_uri: `${process.env.REACT_APP_BASE_URL}/login/callback`,
        silent_redirect_uri: `${process.env.REACT_APP_BASE_URL}/logout`,
        post_logout_redirect_uri: `${process.env.REACT_APP_BASE_URL}/logout`,
        response_type: "id_token token",
        scope:
          "openid profile email skoruba_identity_admin_api IdentityServerApi",
      };
      this.userManagerPromise = import("oidc-client").then(
        ({ UserManager }) => new UserManager(settings)
      );
    }
    return this.userManagerPromise;
  }

  public async getUser(): Promise<User | null> {
    const userManager = await this.getUserManager();
    return userManager.getUser();
  }

  public async login(): Promise<void> {
    const userManager = await this.getUserManager();
    return userManager.signinRedirect();
  }

  public async signinRedirectCallback(): Promise<User> {
    const userManager = await this.getUserManager();
    return userManager.signinRedirectCallback();
  }

  public async renewToken(): Promise<User> {
    const userManager = await this.getUserManager();
    return userManager.signinSilent();
  }

  public async logout(): Promise<void> {
    const userManager = await this.getUserManager();
    return userManager.signoutRedirect();
  }
}

export const AuthServiceInstance = new AuthService();
